var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 0H1.6C1.30826 0 1.02847 0.115893 0.822183 0.322183C0.615893 0.528473 0.5 0.808262 0.5 1.1V18.9C0.5 19.1917 0.615893 19.4715 0.822183 19.6778C1.02847 19.8841 1.30826 20 1.6 20H11.18V12.25H8.58V9.25H11.18V7C11.1261 6.47176 11.1885 5.93813 11.3627 5.43654C11.5369 4.93495 11.8188 4.47755 12.1885 4.09641C12.5582 3.71528 13.0068 3.41964 13.5028 3.23024C13.9989 3.04083 14.5304 2.96225 15.06 3C15.8383 2.99463 16.6163 3.03469 17.39 3.12V5.82H15.8C14.54 5.82 14.3 6.42 14.3 7.29V9.22H17.3L16.91 12.22H14.3V20H19.4C19.5445 20 19.6875 19.9715 19.821 19.9163C19.9544 19.861 20.0757 19.78 20.1778 19.6778C20.28 19.5757 20.361 19.4544 20.4163 19.321C20.4715 19.1875 20.5 19.0445 20.5 18.9V1.1C20.5 0.955546 20.4715 0.812506 20.4163 0.679048C20.361 0.54559 20.28 0.424327 20.1778 0.322183C20.0757 0.220038 19.9544 0.139013 19.821 0.0837326C19.6875 0.0284524 19.5445 0 19.4 0Z",
    fill: "#FFDB6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ccd7415c1ee3fe5f2d55510d30ffccea.svg";
export { ForwardRef as ReactComponent };